import type Lenis from "lenis";

/**
 * SmoothScroll owns the Lenis instance, but overlays that sit above the page need to
 * freeze it while they are open, otherwise the page keeps gliding behind them. This is
 * the handshake between the two: SmoothScroll registers, overlays pause and resume.
 */
let instance: Lenis | null = null;

export const registerLenis = (lenis: Lenis | null) => {
  instance = lenis;
};

export const pauseScroll = () => instance?.stop();

export const resumeScroll = () => instance?.start();
